<template>
  <div id="app">
<!--      <router-link to="/"></router-link>-->
<!--    <div id="nav">-->
<!--      <router-link to="/">Home</router-link> |-->
<!--      <router-link to="/about">About</router-link>-->
<!--    </div>-->
    <router-view/>
  </div>
</template>

<script>
import {createScript,isAlipay,isWeixin} from '@/utils/environment.js'
export default {
  name: 'App',
  methods:{
    rem() {
      let idealViewWidth = document.body.clientWidth;
      const BASICVALUE = 750;
      idealViewWidth = idealViewWidth > 1024 ? 1024 : idealViewWidth;
      let fontSize = (idealViewWidth / BASICVALUE) * 100;
      document.documentElement.style.fontSize = fontSize + 'px';
    },
    emitHandleFontSize() {
      setTimeout(()=>{
        let idealViewWidth = document.body.clientWidth;
        const BASICVALUE = 750;
        idealViewWidth = idealViewWidth > 1024 ? 1024 : idealViewWidth;
        let fontSize = (idealViewWidth / BASICVALUE) * 100;
        var docEl = document.documentElement;
        var actualSize = parseFloat(window.getComputedStyle(docEl)["font-size"]);
        if (Math.abs(actualSize - fontSize) > 1) {
            this.JSBridgeFontSize();
            this.emitHandleFontSize();
            this.handleFontSize();
            return
        }
        document.documentElement.style.fontSize = fontSize + 'px';
      },100)
    },
    JSBridgeFontSize() {
      //禁止页面跟随系统字体变化,不禁止会出现样式错乱
      (function() {
              if (document.addEventListener) {
                  document.addEventListener("WeixinJSBridgeReady", handleFontSize, false);
              } else if (document.attachEvent) {
                  document.attachEvent("WeixinJSBridgeReady", handleFontSize);
                  document.attachEvent("onWeixinJSBridgeReady", handleFontSize);  
              }
              function handleFontSize() {
                  // 设置网页字体为默认大小
				  if (window.WeixinJSBridge) {
					  WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize' : '2' });
					  // 重写设置网页字体大小的事件
					  WeixinJSBridge.on('menu:setfont', function() {
						  WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize' : '2' });
					  });
				  }
              }
      })();
    },
    handleFontSize() {
		if(window.WeixinJSBridge){
        // 设置网页字体为默认大小
        WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize' : '2' });
        // 重写设置网页字体大小的事件
        WeixinJSBridge.on('menu:setfont', function() {
            WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize' : '2' });
        });
		}
    }
  },
  created() {
    this.JSBridgeFontSize();
    this.emitHandleFontSize();
    if(isAlipay()){
        createScript('https://appx/web-view.min.js','appx')
    }

    this.rem()
    window.onresize = ()=>{
      this.JSBridgeFontSize();
      this.emitHandleFontSize();
      this.rem();
    };
    (function () {
      if (!/eruda=true/.test(window.location) && localStorage.getItem('active-eruda') != 'true') return;
      var eruda = require('eruda/eruda.js')
      eruda.init();
    })();
	
  },
  components: {

  }
}
</script>

<style lang="scss">
  *{
    padding: 0;
    margin: 0;
  }
  @import './styles/app.scss';
 @media screen and (min-width: 960px) {
	 .el-select-dropdown__item{
    height: 0.7rem !important;
    line-height: 0.7rem !important;
   }
    .van-picker-column{
       font-size: 0.3rem !important;
    }
    .van-hairline-unset--top-bottom{
        height: 1rem !important;
    }
    .van-picker{
        height: 3rem;
     }
    // .van-picker-column__item{
    //    line-height: 1rem !important;
    //    height: 1rem !important;
    // }
    //  .van-picker-column__item--selected{
    //   height: 1rem !important;
    // }
    .el-input--medium .el-input__inner{
      height: 0.6rem !important;
      line-height: 0.6rem !important;
    }
    .el-input--medium{
      font-size: 0.2rem !important;
    }
  
  
	.el-scrollbar {
	    > .el-scrollbar__bar {
	        opacity: 1 !important;
	    }
	}
   
 
	}
  html,body{
    height: 100%;
  }

  #app{
    height: 100%;
  }
  .row {
    display: flex;
    flex-wrap: wrap;
  }
  html{
    overflow: auto;
  }
  *, :after, :before {
    box-sizing: border-box;
    outline: none;
    -webkit-tap-highlight-color: transparent;
  }

  body, div, dl, dt, dd, ul, ol, li, h1, h2, h3, h4, h5, h6, pre, code, form, input, button, textarea, p, th, td {
    margin: 0;
    padding: 0;
    font-family: Roboto,Helvetica,"PingFang SC", "Helvetica Neue", Helvetica, "Hiragino Sans GB", "Microsoft YaHei", SimSun, sans-serif;
  }

  body {
    font-family: Roboto,Helvetica,"PingFang SC", "Helvetica Neue", Helvetica, "Hiragino Sans GB", "Microsoft YaHei", SimSun, sans-serif;
    font-size: 16px;

    color: #000;
    background-color: #fff;

    -webkit-overflow-scrolling: touch;
  }
  .el-message-box {
    width: 6rem!important;
  }
</style>
